export default function setCoupons() {
  const couponsActions = document.querySelectorAll('[data-coupons-action]');
  const couponsWrapper = document.querySelectorAll('[data-coupons]');
  const copyBtns = document.querySelectorAll('[data-cuopon-copy');

  if (couponsActions.length > 0 && couponsWrapper) {
    couponsActions.forEach((couponsActions) => {
      couponsActions.addEventListener('click', () => {
        couponsWrapper.forEach((wrapper) => {
          wrapper.classList.toggle('-active');
        });
      });
    });
  }

  copyBtns.forEach((copyBtn) => {
    copyBtn.addEventListener('click', () => {
      let targeToCopy = copyBtn.closest('.coupon').querySelector('.coupom-value');
      let buttonInitialText = copyBtn.innerHTML;

      if (targeToCopy) {
        navigator.clipboard.writeText(targeToCopy.innerHTML);
        copyBtn.innerHTML = '<svg><use xlink:href="#icon-copy"></use></svg>Copiado';
        copyBtn.style.pointerEvents = 'none';

        setTimeout(() => {
          copyBtn.innerHTML = buttonInitialText;
          copyBtn.style.pointerEvents = 'all';
        }, 1500);
      }
    });
  });
}
